import * as React from 'react';
import { Calendar, ICalendarProps } from '@uifabric/date-time';
import { dateTimeFormatter, OwaDate, owaDate, asDate } from 'owa-datetime';
import { observer } from 'mobx-react';
import { getCalendarStrings, getTzOrUserTimeZone, getOwaDate } from 'owa-datepicker-common';

export interface InlineCalendarProps
    extends Omit<
        ICalendarProps,
        | 'dateTimeFormatter'
        | 'maxDate'
        | 'minDate'
        | 'onSelectDate'
        | 'showSixWeeksByDefault'
        | 'strings'
        | 'today'
        | 'value'
    > {
    maxDate?: OwaDate;
    minDate?: OwaDate;
    onSelectDate: (date: OwaDate, selectedDateRangeArray?: OwaDate[]) => void;
    value: OwaDate | null | undefined;
    timeZoneId?: string;
}

/** A mini-calendar that is localized and formats dates according to user options */
@observer
export class InlineCalendar extends React.Component<InlineCalendarProps> {
    public static defaultProps: Partial<InlineCalendarProps> = {
        showMonthPickerAsOverlay: true,
    };

    public render() {
        const { maxDate, minDate, onSelectDate, value, timeZoneId, ...calendarProps } = this.props;
        const tzNow = owaDate(getTzOrUserTimeZone(value, timeZoneId), Date.now());

        // Always display 6 weeks in calendar to ensure the height of
        // the control doesn't change as the user moves between months
        return (
            <Calendar
                {...calendarProps}
                dateTimeFormatter={dateTimeFormatter}
                maxDate={asDate(maxDate)}
                minDate={asDate(minDate)}
                onSelectDate={this.onSelectDate}
                showSixWeeksByDefault={true}
                strings={getCalendarStrings()}
                today={asDate(tzNow)}
                value={asDate(value)}
            />
        );
    }

    private onSelectDate = (date: Date, dates?: Date[]) => {
        const { value, onSelectDate, timeZoneId } = this.props;
        const tz = getTzOrUserTimeZone(value, timeZoneId);
        const selectedDate = getOwaDate(tz, date);
        const selectedDates = dates && dates.map(d => getOwaDate(tz, d));
        onSelectDate(selectedDate, selectedDates);
    };
}
